<app-custom-breadcrumb [crumbs]="breadcrumbs" xmlns="http://www.w3.org/1999/html"></app-custom-breadcrumb>
<div class="flex items-center gap-3 my-3">
  <app-back-option-section [loading]="loading"></app-back-option-section>
  <h2>{{ reservationId ? 'Edit Rent Booking - ' + editbleReservation?.refNo : 'Add New Rent Booking' }}</h2>
</div>
<div *ngIf="emailContent" class="fixed top-56 right-10 z-20">
  <button nz-button nzType="primary" nzGhost class="outline-button" (click)="openEmailContentDrawer()">
    Preview Email
  </button>
</div>

<!--form section-->
<div [ngClass]="!loading ? 'block' : 'hidden'">
<section>
  <nz-card>
    <div>
      <h5 class="text-primary">Booking details</h5>

      <span *ngIf="tempBooking"
            class="text-primary text-sm my-4">Agent is '{{ tempBooking?.booking?.bookingDetails?.agent }}'. Check the system agents and select or add new agent.</span>

      <div>
        <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="bookingDetails">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="bookingReceivedDateId" nzRequired>Booking Received Date</nz-form-label>
              <nz-form-control [nzErrorTip]="bookingReceivedDateError">
                <nz-date-picker id="bookingReceivedDateId" class="w-full" formControlName="bookingReceivedDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #bookingReceivedDateError>
                <span *ngIf="formErrors?.bookingDetails?.bookingReceivedDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="bookingTypeId" nzRequired>Booking Type</nz-form-label>
              <nz-form-control [nzErrorTip]="bookingTypeError">
                <nz-select id="bookingTypeId" class="w-full" formControlName="bookingType" nzPlaceHolder="Select Type"
                           (ngModelChange)="checkBookingTypeValidity($event)">
                  <nz-option *ngFor="let op of rentBookingTypeOptions" [nzValue]="op.value"
                             [nzLabel]="op.label"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #bookingTypeError>
                <span *ngIf="formErrors?.bookingDetails?.bookingType?.required">Please select type. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div *ngIf="rentBookingForm.get('bookingDetails').get('bookingType').value === 'THROUGH_AGENT'"
               class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="bookingDetails">
            <nz-form-item class="grid grid-flow-row content-start mb-0">
              <nz-form-label nzFor="brokerNameId" nzRequired>Broker Name</nz-form-label>
              <nz-form-control [nzErrorTip]="brokerNameError">
                <input id="brokerNameId" nz-input type="text" formControlName="brokerName" placeholder="Enter Name"/>
              </nz-form-control>
              <ng-template #brokerNameError>
                <span *ngIf="formErrors?.bookingDetails?.brokerName?.required">Please enter broker name. </span>
              </ng-template>
            </nz-form-item>

            <nz-form-item class="grid grid-flow-row content-start mb-0">
              <nz-form-label nzFor="bookingReferenceNoId" nzRequired>Agent Booking Reference</nz-form-label>
              <nz-form-control [nzErrorTip]="bookingReferenceNoError">
                <input id="bookingReferenceNoId" nz-input type="text" formControlName="bookingReferenceNo"
                       placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #bookingReferenceNoError>
                <span *ngIf="formErrors?.bookingDetails?.bookingReferenceNo.required">Please enter booking reference number. </span>
                <!--                <span *ngIf="formErrors.bookingReferenceNo.maxlength">Maximum 70 letters only. </span>-->
                <!--                <span *ngIf="formErrors.bookingReferenceNo.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
              </ng-template>
            </nz-form-item>

            <div class="col-span-2">
              <div class="flex">
                <nz-form-item style="min-width: 245px" class="grid grid-flow-row content-start mb-0">
                  <nz-form-label nzFor="agentId" nzRequired>Agent</nz-form-label>
                  <nz-form-control [nzErrorTip]="agentError">
                    <nz-select nzShowSearch nzAllowClear id="agentId" class="w-full" formControlName="agent"
                               nzPlaceHolder="Select Agent">
                      <nz-option *ngFor="let op of agentOptions" nzValue="{{op._id}}"
                                 nzLabel="{{op.name}} | {{op.email}}"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #agentError>
                    <span *ngIf="formErrors?.bookingDetails?.agent?.required">Please select agent. </span>
                  </ng-template>
                </nz-form-item>
                <div class="flex items-end ml-2">
                  <button class="outline-button" nz-button nzType="default" (click)="showAddAgentPopup()">Add New Agent
                  </button>
                </div>
              </div>
            </div>
          </div>

        </form>
      </div>
    </div>
  </nz-card>
</section>

<section class="mt-6">
  <nz-card>
    <div class="">
      <h5 class="text-primary">Customer Details</h5>
      <span *ngIf="tempBooking"
            class="text-primary text-sm my-4">Customer is '{{ tempBooking?.booking?.customerDetails?.customer }}'. Check the system customers and select or add new customer.</span>
      <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">
        <div formGroupName="customerDetails">
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2 mb-6">
            <nz-form-item class="grid grid-flow-row content-start mb-0">
              <nz-form-label nzFor="customerId" nzRequired>Customer</nz-form-label>
              <nz-form-control [nzErrorTip]="customerError">
                <nz-select nzShowSearch nzAllowClear id="customerId" class="w-full" formControlName="customer"
                           nzPlaceHolder="Select Customer">
                  <nz-option *ngFor="let op of customerOptions" nzValue="{{op._id}}" nzLabel="{{op.name}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #customerError>
                <span *ngIf="formErrors?.customerDetails?.customer?.required">Please select customer. </span>
              </ng-template>
            </nz-form-item>
            <div class="flex items-end">
              <button class="outline-button" nz-button nzType="default" (click)="showAddCustomerPopup()">Add New
                Customer
              </button>
            </div>
          </div>
          <div *ngIf="expireMsgModalOpen" class="pb-3">
            <nz-alert style="display: inline-block;"  nzType="info" [nzMessage]="expireMsg" class="mb-3 custom-alert" nzShowIcon></nz-alert>
          </div>

          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2 mb-6">
            <nz-form-item class="grid grid-flow-row content-between mb-0">
              <nz-form-label nzFor="customerLocalContactNoId" nzRequired>Customer Local Contact Number</nz-form-label>
              <nz-form-control [nzErrorTip]="localContactNoError">
                <input nz-input type="text" id="customerLocalContactNoId" formControlName="localContactNo"
                       placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #localContactNoError>
                <span *ngIf="formErrors?.customerDetails?.localContactNo.required">Please enter contact number. </span>
                <span *ngIf="formErrors?.customerDetails?.localContactNo.maxlength">Maximum 70 letters only. </span>
                <span *ngIf="formErrors?.customerDetails?.localContactNo.pattern">Only allowed number, please avoid adding special characters or letters. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-between mb-0">
              <nz-form-label nzFor="customerLocalPermitRequirementsId" nzRequired>Local Permit Requirements
              </nz-form-label>
              <nz-form-control [nzErrorTip]="localPermitRequirementsError">
                <nz-select id="customerLocalPermitRequirementsId" class="w-full"
                           formControlName="localPermitRequirements" nzPlaceHolder="Select Requirement">
                  <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                  <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #localPermitRequirementsError>
                <span
                  *ngIf="formErrors?.customerDetails?.localPermitRequirements?.required">Please select requirement. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-between mb-0">
              <nz-form-label nzFor="customerLocalAddressId" nzRequired>Local Address/ Name of the Hotel staying on the
                last day
              </nz-form-label>
              <nz-form-control [nzErrorTip]="bookingReferenceNoError">
                <input nz-input type="text" id="customerLocalAddressId" formControlName="localAddress"
                       placeholder="Enter Address"/>
              </nz-form-control>
              <ng-template #bookingReferenceNoError>
                <span *ngIf="formErrors?.customerDetails?.localAddress.required">Please enter address. </span>
                <!--                <span *ngIf="formErrors.localAddress.maxlength">Maximum 70 letters only. </span>-->
                <!--                <span *ngIf="formErrors.localAddress.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
              </ng-template>
            </nz-form-item>
          </div>
          <div>
            <span nz-checkbox formControlName="localDrivingLicenseCheck" (ngModelChange)="checkValidity($event)"
                  class="mb-4">Local Driving License Details</span>
          </div>
          <div *ngIf="rentBookingForm.get('customerDetails').get('localDrivingLicenseCheck').value"
               class="grid lg:grid-cols-2 gap-2">
            <div class="grid sm:grid-cols-2 gap-2" formGroupName="localDrivingLicenseDetails">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="customerLocalDrivingPermitNumberId" nzRequired>Local Driving Permit number
                </nz-form-label>
                <nz-form-control [nzErrorTip]="localDrivingPermitNumberError">
                  <input nz-input type="text" id="customerLocalDrivingPermitNumberId"
                         formControlName="localDrivingPermitNumber" placeholder="Enter Number"/>
                </nz-form-control>
                <ng-template #localDrivingPermitNumberError>
                  <span
                    *ngIf="formErrors?.localDrivingLicenseDetails?.localDrivingPermitNumber?.required">Please enter permit number. </span>
                  <span
                    *ngIf="formErrors?.localDrivingLicenseDetails?.localDrivingPermitNumber?.maxlength">Maximum 70 letters only. </span>
                  <!--                  <span *ngIf="formErrors?.customerDetails?.localDrivingLicenseDetails.localDrivingPermitNumber.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="customerLDLIssuedDateId" nzRequired>Issue Date</nz-form-label>
                <nz-form-control [nzErrorTip]="issuedDateError">
                  <nz-date-picker id="customerLDLIssuedDateId" class="w-full" formControlName="issuedDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #issuedDateError>
                  <span *ngIf="formErrors?.localDrivingLicenseDetails?.issuedDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="customerLDLExpiryDateId" nzRequired>Expiry Date</nz-form-label>
                <nz-form-control [nzErrorTip]="expiryDateError">
                  <nz-date-picker id="customerLDLExpiryDateId" class="w-full" formControlName="expiryDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #expiryDateError>
                  <span *ngIf="formErrors?.localDrivingLicenseDetails?.expiryDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
            </div>
            <div>
              <h6>Attachments</h6>
              <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                <div>
                  <nz-upload
                    [nzCustomRequest]="localDrivingLicenseUpload" [nzShowUploadList]="false" [nzMultiple]="false">
                    <button nz-button>
                      <span nz-icon nzType="upload"></span>
                      Click to Upload
                    </button>
                  </nz-upload>
                </div>
                <div>
                  <p *ngIf="localDrivingLicenseUploading" class="text-primary my-2">Uploading...</p>
                </div>
                <div class="mt-2 overflow-auto">
                  <div *ngFor="let file of localDrivingLicenseUploadFiles; let i = index"
                       class="flex justify-between items-center mx-3 gap-5">
                    <a target="_blank" href="{{file.url}}">{{ file.name }}</a>
                    <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                          [nzTwotoneColor]="'#ff0000'"
                          class="cursor-pointer" nz-popconfirm
                          nzPopconfirmTitle="Are you sure you want to delete this attachment"
                          (nzOnConfirm)="removeUploadFile(i, 'local-license')"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <span nz-checkbox formControlName="secondDriverCheck" class="mb-4"
                  (nzCheckedChange)="checkSecondDriverCheckValue($event)">Second Driver Details</span>
          </div>
          <div *ngIf="rentBookingForm.get('customerDetails').get('secondDriverCheck').value">
            <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="secondDriverDetails">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverNameId" nzRequired>Driver Name</nz-form-label>
                <nz-form-control [nzErrorTip]="driverNameError">
                  <input nz-input type="text" id="secondDriverNameId" formControlName="driverName"
                         placeholder="Enter Name"/>
                </nz-form-control>
                <ng-template #driverNameError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.driverName?.required">Please enter name. </span>
                  <!--                  <span *ngIf="formErrors.secondDriverDetails.driverName.maxlength">Maximum 70 letters only. </span>-->
                  <!--                  <span *ngIf="formErrors.secondDriverDetails.driverName.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLocalPermitRequirementsId" nzRequired>Local Permit Requirements
                </nz-form-label>
                <nz-form-control [nzErrorTip]="localPermitRequirementsError">
                  <nz-select id="secondDriverLocalPermitRequirementsId" class="w-full"
                             formControlName="localPermitRequirements"
                             nzPlaceHolder="Select Requirement">
                    <nz-option [nzValue]="true" nzLabel="Yes"></nz-option>
                    <nz-option [nzValue]="false" nzLabel="No"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #localPermitRequirementsError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.localPermitRequirements?.required">Please select requirement. </span>
                </ng-template>
              </nz-form-item>
            </div>

            <h6 class="my-2">Passport Details</h6>
            <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="secondDriverDetails">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverPassportNumberId" nzRequired>Passport Number</nz-form-label>
                <nz-form-control [nzErrorTip]="passportNumberError">
                  <input nz-input type="text" id="secondDriverPassportNumberId" formControlName="passportNumber"
                         placeholder="Enter Number"/>
                </nz-form-control>
                <ng-template #passportNumberError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.passportNumber?.required">Please enter passport number. </span>
                  <span
                    *ngIf="formErrors?.secondDriverDetails?.passportNumber?.maxlength">Maximum 70 letters only. </span>
                  <!--                  <span *ngIf="formErrors.secondDriverDetails.passportNumber.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverPassportIssuedDateId" nzRequired>Issue Date</nz-form-label>
                <nz-form-control [nzErrorTip]="passportIssuedDateError">
                  <nz-date-picker id="secondDriverPassportIssuedDateId" class="w-full"
                                  formControlName="passportIssuedDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #passportIssuedDateError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.passportIssuedDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverPassportExpiryDateId" nzRequired>Expiry Date</nz-form-label>
                <nz-form-control [nzErrorTip]="passportExpiryDateError">
                  <nz-date-picker id="secondDriverPassportExpiryDateId" class="w-full"
                                  formControlName="passportExpiryDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #passportExpiryDateError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.passportExpiryDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
            </div>

            <h6 class="my-2">Driving License Details</h6>
            <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="secondDriverDetails">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLicenseNumberId" nzRequired>Driving License Number</nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseNumberError">
                  <input nz-input type="text" id="secondDriverLicenseNumberId" formControlName="drivingLicenseNumber"
                         placeholder="Enter Number"/>
                </nz-form-control>
                <ng-template #drivingLicenseNumberError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.drivingLicenseNumber?.required">Please enter license number. </span>
                  <span
                    *ngIf="formErrors?.secondDriverDetails?.drivingLicenseNumber?.maxlength">Maximum 70 letters only. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLicenseIssuedDateId" nzRequired>Issue Date</nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseIssuedDateError">
                  <nz-date-picker id="secondDriverLicenseIssuedDateId" class="w-full"
                                  formControlName="drivingLicenseIssuedDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #drivingLicenseIssuedDateError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.drivingLicenseIssuedDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLicenseExpiryDateId" nzRequired>Expiry Date</nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseExpiryDateError">
                  <nz-date-picker id="secondDriverLicenseExpiryDateId" class="w-full"
                                  formControlName="drivingLicenseExpiryDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #drivingLicenseExpiryDateError>
                  <span *ngIf="formErrors?.secondDriverDetails?.drivingLicense?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLicenseIssuedCountryId" nzRequired>Driving License Issued Country
                </nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseNumberIssuedCountryError">
                  <input nz-input type="text" id="secondDriverLicenseIssuedCountryId"
                         formControlName="drivingLicenseIssuedCountry"
                         placeholder="Enter Country"/>
                </nz-form-control>
                <ng-template #drivingLicenseNumberIssuedCountryError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.drivingLicenseIssuedCountry?.required">Please enter license issued country. </span>
                </ng-template>
              </nz-form-item>
            </div>

            <h6 class="my-2">Local Driving License Details</h6>
            <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="secondDriverDetails">
              <nz-form-item formGroupName="localDrivingLicenseDetails" class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLocalDrivingPermitNumber" nzRequired>Local Driving Permit number
                </nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseNumberError">
                  <input nz-input type="text" id="secondDriverLocalDrivingPermitNumber"
                         formControlName="localDrivingPermitNumber" placeholder="Enter Number"/>
                </nz-form-control>
                <ng-template #drivingLicenseNumberError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.localDrivingLicenseDetails?.localDrivingPermitNumber?.required">Please enter license number. </span>
                  <span
                    *ngIf="formErrors?.secondDriverDetails?.localDrivingLicenseDetails?.localDrivingPermitNumber?.maxlength">Maximum 70 letters only. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item formGroupName="localDrivingLicenseDetails" class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLDLIssuedDateId" nzRequired>Issue Date</nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseIssuedDateError">
                  <nz-date-picker id="secondDriverLDLIssuedDateId" class="w-full" formControlName="issuedDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #drivingLicenseIssuedDateError>
                            <span
                              *ngIf="formErrors?.secondDriverDetails?.localDrivingLicenseDetails?.issuedDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
              <nz-form-item formGroupName="localDrivingLicenseDetails" class="grid grid-flow-row content-start">
                <nz-form-label nzFor="secondDriverLDLExpiryDateId" nzRequired>Expiry Date</nz-form-label>
                <nz-form-control [nzErrorTip]="drivingLicenseExpiryDateError">
                  <nz-date-picker id="secondDriverLDLExpiryDateId" class="w-full" formControlName="expiryDate"
                                  nzPlaceHolder="Select Date"></nz-date-picker>
                </nz-form-control>
                <ng-template #drivingLicenseExpiryDateError>
                  <span *ngIf="formErrors?.secondDriverDetails?.localDrivingLicenseDetails?.expiryDate?.required">Please select date. </span>
                </ng-template>
              </nz-form-item>
              <div>
                <h6>Attachments</h6>
                <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
                  <div>
                    <nz-upload
                      [nzCustomRequest]="secondDriverLocalDrivingLicenseUpload" [nzShowUploadList]="false"
                      [nzMultiple]="false">
                      <button nz-button>
                        <span nz-icon nzType="upload"></span>
                        Click to Upload
                      </button>
                    </nz-upload>
                  </div>
                  <div>
                    <p *ngIf="secondDriverLocalDrivingLicenseUploading" class="text-primary my-2">Uploading...</p>
                  </div>
                  <div class="mt-2 overflow-auto">
                    <div *ngFor="let file of secondDriverLocalDrivingLicenseUploadFiles; let i = index"
                         class="flex justify-between items-center mx-3 gap-5">
                      <a target="_blank" href="{{file.url}}">{{ file.name }}</a>
                      <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                            [nzTwotoneColor]="'#ff0000'"
                            class="cursor-pointer" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this attachment"
                            (nzOnConfirm)="removeUploadFile(i, 'second-driver-local-license')"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section class="mt-6">
  <nz-card>
    <div class="">
      <h5 class="text-primary">Tour Details</h5>
      <span *ngIf="tempBooking"
            class="text-primary text-sm my-4">Vehicle Category is '{{ tempBooking?.booking?.tourDetails?.vehicleCategory }}
        '. Check the system vehicle categories and select one.</span>
      <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">
        <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="tourDetails">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="vehicleCategoryId" nzRequired>Vehicle Category</nz-form-label>
            <nz-form-control [nzErrorTip]="vehicleCategoryError">
              <nz-select nzShowSearch nzAllowClear id="vehicleCategoryId" class="w-full"
                         formControlName="vehicleCategory"
                         nzPlaceHolder="Select Category">
                <nz-option *ngFor="let data of vehicleCategories" [nzValue]="data._id"
                           [nzLabel]="data.name"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #vehicleCategoryError>
              <span *ngIf="formErrors?.tourDetails?.vehicleCategory?.required">Please select category. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="mileagePreferenceId" nzRequired>Mileage-Limited/Unlimited</nz-form-label>
            <nz-form-control [nzErrorTip]="mileagePreferenceError">
              <nz-select id="mileagePreferenceId" class="w-full" formControlName="mileagePreference"
                         nzPlaceHolder="Select Preference" (ngModelChange)="checkMileagePreferenceValidity($event)">
                <nz-option nzValue="LIMITED" nzLabel="Limited"></nz-option>
                <nz-option nzValue="UNLIMITED" nzLabel="Unlimited"></nz-option>
              </nz-select>
            </nz-form-control>
            <ng-template #mileagePreferenceError>
              <span *ngIf="formErrors?.tourDetails?.mileagePreference?.required">Please select type. </span>
            </ng-template>
          </nz-form-item>

          <nz-form-item *ngIf="rentBookingForm.get('tourDetails').get('mileagePreference').value === 'LIMITED'"
                        class="grid grid-flow-row content-start">
            <nz-form-label nzFor="limitedMileageId" nzRequired>Limited Mileage Allowed (Km)</nz-form-label>
            <nz-form-control [nzErrorTip]="limitedMileageError">
              <nz-input-group nzAddOnAfter="Km">
                <input nz-input type="number" [min]="0" id="limitedMileageId" formControlName="limitedMileage"
                       placeholder="Enter Number"/>
              </nz-input-group>
            </nz-form-control>
            <ng-template #limitedMileageError>
              <span *ngIf="formErrors?.tourDetails?.limitedMileage?.required">Please enter mileage. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="numberOfPassengersId" nzRequired>No. of Passengers</nz-form-label>
            <nz-form-control [nzErrorTip]="numberOfPassengersError">
              <input nz-input type="number" [min]="0" id="numberOfPassengersId" formControlName="numberOfPassengers"
                     placeholder="Enter Number"/>
            </nz-form-control>
            <ng-template #numberOfPassengersError>
              <span *ngIf="formErrors?.tourDetails?.numberOfPassengers?.required">Please enter number. </span>
            </ng-template>
          </nz-form-item>
          <nz-form-item *ngIf="rentBookingForm.get('tourDetails').get('mileagePreference').value === 'LIMITED'"
                        class="grid grid-flow-row content-start">
            <nz-form-label nzFor="costPerExtraMileageId"
                           nzRequired>Cost Per Extra Mileage
            </nz-form-label>
            <nz-form-control [nzErrorTip]="costPerExtraMileageError">
              <!--              <input nz-input type="text" formControlName="costPerExtraMileage" placeholder="Enter Number"/>-->
              <nz-input-number-group [nzAddOnAfter]="costPerExtraMilAddOnAfterTemplate">
                <nz-input-number id="costPerExtraMileageId" formControlName="costPerExtraMileage"
                                 [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                 [nzMin]="0"></nz-input-number>
              </nz-input-number-group>
              <ng-template #costPerExtraMilAddOnAfterTemplate>
                <nz-select id="costPerExtraMileageCurrencyId" formControlName="costPerExtraMileageCurrency"
                           [nzPlaceHolder]="'...'" style="width: 75px">
                  <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                             [nzLabel]="op.currencyCode"></nz-option>
                </nz-select>
              </ng-template>
            </nz-form-control>
            <ng-template #costPerExtraMileageError>
              <span *ngIf="formErrors?.tourDetails?.costPerExtraMileage?.required">Please enter value. </span>
            </ng-template>
          </nz-form-item>
        </div>

        <div formGroupName="tourDetails">
          <h6 class="my-2">Arrival Details</h6>
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="arrivalInformation">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="arrivalDateId" nzRequired>Arrival Date</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalDateError">
                <nz-date-picker id="arrivalDateId" class="w-full" formControlName="arrivalDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #arrivalDateError>
                <span
                  *ngIf="formErrors?.arrivalInformation?.arrivalDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="arrivalTimeId" nzRequired>Arrival Time</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalTimeError">
                <nz-time-picker id="arrivalTimeId" class="w-full" formControlName="arrivalTime"
                                nzPlaceHolder="Select Time"  [nzFormat]="'HH:mm'" ></nz-time-picker>
              </nz-form-control>
              <ng-template #arrivalTimeError>
                <span
                  *ngIf="formErrors?.arrivalInformation?.arrivalTime?.required">Please select time. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="arrivalFlightNoId">Arrival Flight No.</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalFlightNoError">
                <input nz-input type="text" id="arrivalFlightNoId" formControlName="arrivalFlightNo"
                       placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #arrivalFlightNoError>
                <span
                  *ngIf="formErrors?.arrivalInformation?.arrivalFlightNo?.required">Please enter flight number. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="pickUpLocationId" nzRequired>Pick Up Address</nz-form-label>
              <nz-form-control [nzErrorTip]="pickUpLocationError">
                <input nz-input type="text" id="pickUpLocationId" formControlName="pickUpLocation"
                       placeholder="Enter Address"/>
              </nz-form-control>
              <ng-template #pickUpLocationError>
                <span
                  *ngIf="formErrors?.arrivalInformation?.pickUpLocation?.required">Please enter address. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="arrivalHandlerId">Arrival Handler</nz-form-label>
              <nz-form-control [nzErrorTip]="arrivalHandlerError">
                <nz-select nzShowSearch nzAllowClear class="w-full" id="arrivalHandlerId"
                           formControlName="arrivalHandler"
                           nzPlaceHolder="Select Handler">
                  <nz-option *ngFor="let op of bookingHandlerOptions" nzValue="{{op?._id}}"
                             nzLabel="{{op?.name}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #arrivalHandlerError>
                <span
                  *ngIf="formErrors?.arrivalInformation?.arrivalHandler?.required">Please select handler. </span>
              </ng-template>
            </nz-form-item>
          </div>

          <h6 class="my-2">Departure Details</h6>
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="departureInformation">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="departureDateId" nzRequired>Departure Date</nz-form-label>
              <nz-form-control [nzErrorTip]="departureDateError">
                <nz-date-picker id="departureDateId" class="w-full" formControlName="departureDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #departureDateError>
                <span
                  *ngIf="formErrors?.departureInformation?.departureDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="departureTimeId" nzRequired>Departure Time</nz-form-label>
              <nz-form-control [nzErrorTip]="departureTimeError">
                <nz-time-picker id="departureTimeId" class="w-full" formControlName="departureTime"
                                nzPlaceHolder="Select Time" [nzFormat]="'HH:mm'" ></nz-time-picker>
              </nz-form-control>
              <ng-template #departureTimeError>
                <span
                  *ngIf="formErrors?.departureInformation?.departureTime?.required">Please select time. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="departureFlightNoId">Departure Flight No.</nz-form-label>
              <nz-form-control [nzErrorTip]="departureFlightNoError">
                <input nz-input type="text" id="departureFlightNoId" formControlName="departureFlightNo"
                       placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #departureFlightNoError>
                <span
                  *ngIf="formErrors?.departureInformation?.departureFlightNo?.required">Please enter flight number. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="dropOffLocationId" nzRequired>Drop Off Address</nz-form-label>
              <nz-form-control [nzErrorTip]="dropOffLocationError">
                <input nz-input type="text" id="dropOffLocationId" formControlName="dropOffLocation"
                       placeholder="Enter Address"/>
              </nz-form-control>
              <ng-template #dropOffLocationError>
                <span
                  *ngIf="formErrors?.departureInformation?.dropOffLocation?.required">Please enter address. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="dropOffCityId" nzRequired>Drop Off City</nz-form-label>
              <nz-form-control [nzErrorTip]="dropOffLocationError">
                <input nz-input type="text" id="dropOffCityId" formControlName="dropOffCity"
                       placeholder="Enter Location"/>
              </nz-form-control>
              <ng-template #dropOffLocationError>
                <span
                  *ngIf="formErrors?.departureInformation?.dropOffCity?.required">Please enter city. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="departureHandlerId">Departure Handler</nz-form-label>
              <nz-form-control [nzErrorTip]="departureHandlerError">
                <nz-select nzShowSearch nzAllowClear class="w-full" id="departureHandlerId"
                           formControlName="departureHandler"
                           nzPlaceHolder="Select Handler">
                  <nz-option *ngFor="let op of bookingHandlerOptions" nzValue="{{op?._id}}"
                             nzLabel="{{op?.name}}"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #departureHandlerError>
                <span
                  *ngIf="formErrors?.departureInformation?.departureHandler?.required">Please select handler. </span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>
      </form>


      <nz-divider class="custom-margin"></nz-divider>
      <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2">
        <div class="grid grid-flow-row content-end">
          <div class="flex items-center"><span class="text-red-500 mx-1 text-[10px]">*</span> Number of Days
          </div>
          <span class="text-primary text-sm mb-2">
                ( Auto calculate when arrival and departure dates and times are inserted. )</span>
          <input [disabled]="true" nz-input type="number" [(ngModel)]="numberOfDays"
                 placeholder="Enter Number"/>
          <span *ngIf="!haveNumberOfDays" class="text-red-500">number of days required. </span>
        </div>
      </div>
      <nz-divider class="custom-margin"></nz-divider>

      <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">
        <div formGroupName="tourDetails">
          <h6 class="my-2">Actual Details</h6>
          <div class="grid sm:grid-cols-2 xl:grid-cols-4 gap-2" formGroupName="actualInformation">
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="actualStartDateId">Actual Start Date</nz-form-label>
              <nz-form-control [nzErrorTip]="actualStartDateError">
                <nz-date-picker id="actualStartDateId" class="w-full" formControlName="actualStartDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #actualStartDateError>
                                <span
                                  *ngIf="formErrors?.actualInformation?.actualStartDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="actualStartTimeId">Actual Start Time</nz-form-label>
              <nz-form-control [nzErrorTip]="actualStartTimeError">
                <nz-time-picker id="actualStartTimeId" class="w-full" formControlName="actualStartTime"
                                nzPlaceHolder="Select Time" [nzFormat]="'HH:mm'" ></nz-time-picker>
              </nz-form-control>
              <ng-template #actualStartTimeError>
                                <span
                                  *ngIf="formErrors?.actualInformation?.actualStartTime?.required">Please select time. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="actualEndDateId">Actual End Date</nz-form-label>
              <nz-form-control [nzErrorTip]="actualEndDateError">
                <nz-date-picker id="actualEndDateId" class="w-full" formControlName="actualEndDate"
                                nzPlaceHolder="Select Date"></nz-date-picker>
              </nz-form-control>
              <ng-template #actualEndDateError>
                                <span
                                  *ngIf="formErrors?.actualInformation?.actualEndDate?.required">Please select date. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="actualEndTimeId">Actual End Time</nz-form-label>
              <nz-form-control [nzErrorTip]="actualEndTimeError">
                <nz-time-picker id="actualEndTimeId" class="w-full" formControlName="actualEndTime"
                                nzPlaceHolder="Select Time" [nzFormat]="'HH:mm'" ></nz-time-picker>
              </nz-form-control>
              <ng-template #actualEndTimeError>
                                <span
                                  *ngIf="formErrors?.actualInformation?.actualEndTime?.required">Please select time. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="isExtendedBookingId">Extend Booking</nz-form-label>
              <nz-form-control [nzErrorTip]="isExtendedBookingError">
                <nz-select id="isExtendedBookingId" class="w-full" formControlName="isExtendedBooking"
                           nzPlaceHolder="Select Preference" (ngModelChange)="checkIsTourExtended($event)">
                  <nz-option [nzValue]="true" [nzLabel]="'Yes'"></nz-option>
                  <nz-option [nzValue]="false" [nzLabel]="'No'"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #isExtendedBookingError>
                <!--                <span-->
                <!--                  *ngIf="formErrors?.tourDetails.actualInformation.isExtendedBooking?.required">Please select type. </span>-->
              </ng-template>
            </nz-form-item>
            <nz-form-item
              *ngIf="rentBookingForm?.get('tourDetails').get('actualInformation').get('isExtendedBooking').value"
              class="grid grid-flow-row content-start">
              <nz-form-label nzFor="noOfDaysId">Number of Days</nz-form-label>
              <nz-form-control [nzErrorTip]="noOfDaysError">
                <input nz-input type="number" [min]="0" id="noOfDaysId" formControlName="noOfDays"
                       placeholder="Enter Number"/>
              </nz-form-control>
              <ng-template #noOfDaysError>
                <span *ngIf="formErrors?.actualInformation?.noOfDays?.required">Please enter number of days. </span>
              </ng-template>
            </nz-form-item>
          </div>
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section
  *ngIf="!reservationId || (reservationId && (editbleReservation?.status === 'RESERVATION' || editbleReservation?.status === 'CANCELLED')) "
  class="mt-6">
  <!--<section class="mt-10">-->
  <nz-card>
    <div class="">
      <h5 class="text-primary ">Allocation Details</h5>
      <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">

        <h6 class="my-2">Vehicle Allocation</h6>
        <div class="grid sm:grid-cols-1 xl:grid-cols-2 gap-4" formGroupName="allocationDetails">
          <div>
            <div class="grid lg:grid-cols-2 gap-2 ">
              <span nz-checkbox formControlName="isUpgraded" class="mb-3"
                    (nzCheckedChange)="setValues($event, 'upgrade')">Vehicle Upgrade</span>
              <span nz-checkbox formControlName="isDowngraded" class="mb-3 custom-value_box"
                    (nzCheckedChange)="setValues($event, 'downgrade')">Vehicle Downgrade</span>
            </div>
            <div
              *ngIf="rentBookingForm.get('allocationDetails').get('isUpgraded').value || rentBookingForm.get('allocationDetails').get('isDowngraded').value"
              class="grid xl:grid-cols-2 gap-2">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label nzFor="allocationSectionVehicleCategoryId" nzRequired>Vehicle Category</nz-form-label>
                <nz-form-control [nzErrorTip]="vehicleCategoryError">
                  <nz-select nzShowSearch nzAllowClear id="allocationSectionVehicleCategoryId" class="w-full"
                             formControlName="vehicleCategory" nzPlaceHolder="Select Preference"
                             (ngModelChange)="getVehicles($event)">
                    <nz-option *ngFor="let data of vehicleCategories" [nzValue]="data._id"
                               [nzLabel]="data.name"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #vehicleCategoryError>
                  <span *ngIf="formErrors?.allocationDetails?.vehicleCategory?.required">Please select category. </span>
                </ng-template>
              </nz-form-item>
            </div>

            <div class="grid xl:grid-cols-2 gap-2">
              <nz-form-item class="grid grid-flow-row content-start">
                <nz-form-label *ngIf="(rentBookingForm?.get('allocationDetails').get('isDriverPromote').value &&
                  rentBookingForm?.get('allocationDetails').get('driverCategory').value === 'SR_DRIVER') ||
                  !rentBookingForm?.get('allocationDetails').get('isDriverPromote').value ||
                  (!rentBookingForm?.get('allocationDetails').get('isDriverPromote').value &&
                  !rentBookingForm?.get('allocationDetails').get('driverCategory').value) ||
                  (rentBookingForm?.get('allocationDetails').get('isDriverPromote').value &&
                  !rentBookingForm?.get('allocationDetails').get('driverCategory').value)"
                               nzFor="allocatedVehicleId">Allocated Vehicle
                </nz-form-label>
                 <div class="flex items-center gap-3 mb-2">
                  <button (click)="refreshVehicles()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                  </button>
                  <h6 class="font-normal">Refresh before you allocate the vehicle</h6>
                 </div>
                <nz-form-label
                  *ngIf="rentBookingForm?.get('allocationDetails').get('isDriverPromote').value &&
                  rentBookingForm?.get('allocationDetails').get('driverCategory').value === 'OUTSOURCE_DRIVER'"
                  nzFor="allocatedVehicleId">Allocated Vehicle
                </nz-form-label>
                <nz-form-control [nzErrorTip]="allocatedVehicleError">
                  <nz-select nzShowSearch nzAllowClear id="allocatedVehicleId" class="w-full"
                             formControlName="allocatedVehicle" nzPlaceHolder="Select Preference"
                             (ngModelChange)="getFleetVehicle($event)">
                    <nz-option *ngFor="let op of fleetsOptions" nzValue="{{op._id}}" nzLabel="{{op.vehicleName}}" [nzDisabled]="disableSelectedVehicle(op._id)"></nz-option>
<!--                    <nz-option nzCustomContent *ngFor="let op of fleetsOptions" nzValue="{{op._id}}" nzLabel="{{op.vehicleName}}">-->
<!--                      <div class="flex items-center fleet-availability-status">-->
<!--                        <div [nz-tooltip]="getVehicleAvailabilityIcon(op.availabilityStatus)?.label" class="vehicle-status-mark {{getVehicleAvailabilityIcon(op.availabilityStatus)?.bgColor}}"></div>-->
<!--                        <div>{{op.vehicleName}}</div>-->
<!--                      </div>-->
<!--                    </nz-option>-->
                  </nz-select>
                </nz-form-control>
                <ng-template #allocatedVehicleError>
                  <span *ngIf="formErrors?.allocationDetails?.allocatedVehicle?.required">Please select vehicle. </span>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="fleetsFetching">Loading...</p>
              </nz-form-item>
            </div>

            <nz-divider></nz-divider>

            <div
              *ngIf="rentBookingForm.get('allocationDetails').get('isUpgraded').value">
              <span nz-checkbox formControlName="isComplementary" class="mb-4">Complementary</span>
              <nz-form-item *ngIf="rentBookingForm.get('allocationDetails').get('isComplementary').value"
                            class="grid grid-flow-row content-start">
                <nz-form-label nzFor="reasonId">Reason</nz-form-label>
                <nz-form-control [nzErrorTip]="reasonError">
              <textarea nz-input id="reasonId" formControlName="reason" placeholder="Enter Reason"
                        [nzAutosize]="{ minRows: 5, maxRows: 5 }"></textarea>
                </nz-form-control>
                <ng-template #reasonError>
                  <span *ngIf="formErrors?.allocationDetails?.reason?.maxlength">Maximum 150 letters only. </span>
                </ng-template>
              </nz-form-item>
            </div>

            <div class="grid xl:grid-cols-2">
              <nz-form-item>
                <nz-form-label nzFor="fuelTypeId" nzRequired
                               *ngIf="!(this.rentBookingForm
                             .get('allocationDetails')
                             .get('driverCategory').value === 'OUTSOURCE_DRIVER')">Fuel Type
                </nz-form-label>
                <nz-form-label
                  *ngIf="this.rentBookingForm.get('allocationDetails').get('driverCategory').value === 'OUTSOURCE_DRIVER'"
                  nzFor="fuelTypeId">Fuel Type
                </nz-form-label>
                <nz-form-control [nzErrorTip]="fuelTypeError">
                  <nz-select id="fuelTypeId" class="w-full" formControlName="fuelType"
                             nzPlaceHolder="Select Preference">
                    <nz-option nzValue="PETROL_95_OCT" nzLabel="Petrol 95 Oct"></nz-option>
                    <nz-option nzValue="SUPER_DIESEL" nzLabel="Super Diesel"></nz-option>
                    <nz-option nzValue="ELECTRIC" nzLabel="Electric"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #fuelTypeError>
                  <span *ngIf="formErrors?.allocationDetails?.fuelType?.required">Please select fuel type. </span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>

          <div>
            <span nz-checkbox formControlName="isDriverPromote" class="mb-4" (ngModelChange)="checkValue($event)">Driver Promotion</span>
            <div *ngIf="rentBookingForm.get('allocationDetails').get('isDriverPromote').value">
              <div class="grid grid-cols-2 gap-2">
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="driverPromotionDueId" nzRequired>Driver Promotion Due to</nz-form-label>
                  <nz-form-control [nzErrorTip]="driverPromotionDueError">
                    <nz-select id="driverPromotionDueId" [nzDropdownRender]="renderTemplate" class="w-full"
                               formControlName="driverPromotionDue"
                               nzPlaceHolder="Select Preference">
                      <nz-option *ngFor="let item of driverPromotionDueOptions" [nzLabel]="item"
                                 [nzValue]="item"></nz-option>
                    </nz-select>
                    <ng-template #renderTemplate>
                      <nz-divider></nz-divider>
                      <div class="flex flex-col justify-center mx-3">
                        <input type="text" nz-input #inputElement/>
                        <a class="text-center m-1" (click)="addDriverPromotionDue(inputElement)">
                          <span nz-icon nzType="plus"></span>
                          Add item
                        </a>
                      </div>
                    </ng-template>
                  </nz-form-control>
                  <ng-template #driverPromotionDueError>
                    <span
                      *ngIf="formErrors?.allocationDetails?.driverPromotionDue?.required">Please select reason. </span>
                  </ng-template>
                </nz-form-item>
                <nz-form-item class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="driverCategoryId" nzRequired>Driver Category</nz-form-label>
                  <nz-form-control [nzErrorTip]="driverCategoryError">
                    <nz-select id="driverCategoryId" class="w-full" formControlName="driverCategory"
                               nzPlaceHolder="Select Preference"
                               (ngModelChange)="getDriverOptions($event)">
                      <nz-option nzValue="SR_DRIVER" nzLabel="SR Drivers"></nz-option>
                      <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsourced Drivers"></nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #driverCategoryError>
                    <span
                      *ngIf="formErrors?.allocationDetails?.driverCategory?.required">Please select category. </span>
                  </ng-template>
                </nz-form-item>
              </div>
              <div>
                <span nz-checkbox formControlName="isDriverPromotionCompCheck" class="mb-4">Complementary</span>
                <nz-form-item *ngIf="rentBookingForm.get('allocationDetails').get('isDriverPromotionCompCheck').value"
                              class="grid grid-flow-row content-start">
                  <nz-form-label nzFor="driverPromotionReasonId">Reason</nz-form-label>
                  <nz-form-control [nzErrorTip]="driverPromotionReasonError">
              <textarea nz-input id="driverPromotionReasonId" formControlName="driverPromotionReason"
                        placeholder="Enter Reason"
                        [nzAutosize]="{ minRows: 5, maxRows: 5 }"></textarea>
                  </nz-form-control>
                  <ng-template #driverPromotionReasonError>
                    <span
                      *ngIf="formErrors?.allocationDetails?.driverPromotionReason?.maxlength">Maximum 150 letters only. </span>
                  </ng-template>
                </nz-form-item>
              </div>
            </div>
            
            <div *ngIf="rentBookingForm.get('allocationDetails').get('driverCategory').value &&
            rentBookingForm.get('allocationDetails').get('isDriverPromote').value"
                 >
                 <div class="flex items-center gap-3 mb-3">
                  <button (click)="refreshDrivers()" class="px-[5px]" nz-button nzType="primary"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-rotate-cw"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>
                  </button>
                  <h6 class="font-normal">Refresh before you allocate the driver</h6>
                 </div>
                
              <div class="grid sm:grid-cols-2 gap-2 mb-6">
                <nz-form-item class="grid grid-flow-row content-start mb-0">
                  <nz-form-label nzFor="allocatedDriverId" nzRequired>Allocated Driver</nz-form-label>
                  <nz-form-control [nzErrorTip]="allocatedDriverError">
                    <nz-select nzShowSearch nzAllowClear id="allocatedDriverId" class="w-full"
                               formControlName="allocatedDriver" nzPlaceHolder="Select Preference"
                               (ngModelChange)="getSupplierVehicles($event);getDriver($event)">
                      <!--                    <nz-option nzValue="SR_DRIVER" nzLabel="SR Drivers"></nz-option>-->
                      <!--                    <nz-option nzValue="OUTSOURCE_DRIVER" nzLabel="Outsourced Drivers"></nz-option>-->
  <!--                    <nz-option *ngFor="let op of driverOptions" nzValue="{{op._id}}"-->
  <!--                               nzLabel="{{op.fullName}}"></nz-option>-->
                      <nz-option nzCustomContent *ngFor="let op of driverOptions" nzValue="{{op._id}}" [nzLabel]="op.fullName">
                        <div class="flex items-center driver-availability-status">
                          <div [nz-tooltip]="getDriverAvailabilityIcon(op.driverAvailability)?.label" class="vehicle-status-mark {{getDriverAvailabilityIcon(op.driverAvailability)?.bgColor}}"></div>
                          <div>{{op.fullName}}</div>
                        </div>
                      </nz-option>
                    </nz-select>
                  </nz-form-control>
                  <ng-template #allocatedDriverError>
                    <span *ngIf="formErrors?.allocationDetails.allocatedDriver?.required">Please select driver. </span>
                  </ng-template>
                  <p class="my-2 text-primary text-sm" *ngIf="driversFetching">Loading...</p>
                </nz-form-item>
                <div class="flex items-end">
                  <button class="outline-button" nz-button nzType="default" (click)="showAddDriverPopup()">Add New
                    Driver
                  </button>
                </div>
              </div>
            </div>
            <div *ngIf="((rentBookingForm.get('allocationDetails').get('driverCategory').value === 'OUTSOURCE_DRIVER'))"
                 class="grid sm:grid-cols-2 gap-2 mb-6">
              <nz-form-item class="grid grid-flow-row content-start mb-0">
                <nz-form-label nzFor="allocatedDriverVehicleId" nzRequired>Allocated Vehicle</nz-form-label>
                <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">
                  <nz-select nzShowSearch nzAllowClear id="allocatedDriverVehicleId" class="w-full"
                             formControlName="allocatedDriverVehicle" nzPlaceHolder="Select Preference">
                    <nz-option *ngFor="let op of supplierVehicleOptions" nzValue="{{op?._id}}"
                               nzLabel="{{op?.registerNumber}} | {{op?.vehicleModel}}"></nz-option>
                  </nz-select>
                </nz-form-control>
                <ng-template #allocatedDriverVehicleError>
                  <span
                    *ngIf="formErrors?.allocationDetails.allocatedDriverVehicle?.required">Please select supplier vehicle. </span>
                </ng-template>
                <p class="my-2 text-primary text-sm" *ngIf="supplierVehiclesFetching">Loading...</p>
              </nz-form-item>
              <div class="flex items-end">
                <button class="outline-button" nz-button nzType="default" nz-popconfirm
                        (click)="showAddVehicleToSupplier()">Add New Vehicle
                </button>
              </div>
            </div>
            <div *ngIf="((rentBookingForm.get('allocationDetails').get('driverCategory').value === 'OUTSOURCE_DRIVER'))"
                 class="grid sm:grid-cols-2 gap-2 mb-6">
              <nz-form-item class="grid grid-flow-row content-start mb-0">
                <nz-form-label nzFor="outsourcedRateId" nzRequired>Outsourced Rate</nz-form-label>
                <nz-form-control [nzErrorTip]="allocatedDriverVehicleError">
                  <nz-input-number-group [nzAddOnAfter]="addOnAfterTemplate">
                    <nz-input-number id="outsourcedRateId" formControlName="outsourcedRate"
                                     [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                     [nzMin]="0"></nz-input-number>
                  </nz-input-number-group>
                  <ng-template #addOnAfterTemplate>
                    <nz-select formControlName="outsourcedRateCurrency"
                               [nzPlaceHolder]="'...'" style="width: 75px">
                      <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                                 [nzLabel]="op.currencyCode"></nz-option>
                    </nz-select>
                  </ng-template>
                </nz-form-control>
                <ng-template #allocatedDriverVehicleError>
                  <span
                    *ngIf="formErrors?.allocationDetails.oursourcedRate?.required">Please enter price rate </span>
                </ng-template>
              </nz-form-item>
            </div>
          </div>

          <!--          <div class="grid sm:grid-cols-1 xl:grid-cols-2 gap-2">-->

          <div *ngIf="rentBookingForm.get('allocationDetails.driverCategory').value !== 'OUTSOURCE_DRIVER'"
               class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3" style="min-height: 200px">
            <div>
              <div class="sub-section" style="height: 100%">
                <img width="90%" [src]="this.allocatedVehicle.image" alt="image">
              </div>
            </div>
            <div>
              <div style="height: 100%">
                <div class="mb-5 mt-5">
                  <p class="subject-name">Registration Number</p>
                  <p class="subject-data">{{ this.allocatedVehicle.registrationNo }}</p>
                </div>
              </div>
            </div>
            <div>
              <div style="height: 100%">
                <div class="mb-5 mt-5">
                  <p class="subject-name">No. Of Seats</p>
                  <p class="subject-data">{{ this.allocatedVehicle.seats }}</p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="rentBookingForm.get('allocationDetails').get('isDriverPromote').value"
               class="grid sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
            <div>
              <div class="sub-section" style="height: 100%">
                <div class="item-row mb-5">
                  <p class="subject-name">Driver Name: </p>
                  <p class="subject-data">{{ allocatedDriver.name }}</p>
                </div>
                <div class="item-row mb-5">
                  <p class="subject-name">Mobile Number: </p>
                  <p class="subject-data">{{ allocatedDriver.mobileNo }}</p>
                </div>
                <div class="item-row mb-5" *ngIf="allocatedDriver.supplier !== '-'">
                  <p class="subject-name">Supplier: </p>
                  <p class="subject-data">{{ allocatedDriver.supplier }}</p>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="rentBookingForm.get('allocationDetails.driverCategory').value === 'OUTSOURCE_DRIVER'"
               class="grid sm:grid-cols-1 gap-3" style="min-height: 200px">
            <div>
              <div class="sub-section" style="height: 100%">
                <div class="mb-5 item-row">
                  <p class="subject-name">Registration Number</p>
                  <p class="subject-data">{{ this.allocatedVehicle.registrationNo }}</p>
                </div>
                <div class="mb-5 item-row">
                  <p class="subject-name">Model</p>
                  <p class="subject-data">{{ this.allocatedVehicle.model }}</p>
                </div>
              </div>
            </div>
          </div>
          <!--          </div>-->
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section class="mt-6">
  <nz-card>
    <div>
      <h5 class="text-primary ">Booking Cost Details</h5>
      <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">
        <div class="grid lg:grid-cols-2 gap-2" formGroupName="bookingCostInformation">
          <div class="grid sm:grid-cols-2 gap-2">
            <nz-form-item class="grid grid-flow-row mb-8 content-start">
              <nz-form-label nzFor="paymentTypeId" nzRequired>Payment Type</nz-form-label>
              <nz-form-control [nzErrorTip]="paymentTypeError">
                <nz-select id="paymentTypeId" class="w-full" formControlName="paymentType"
                           (ngModelChange)="setBookingCostInputs($event)"
                           nzPlaceHolder="Select Preference">
                  <nz-option nzValue="PREPAID" nzLabel="Pre-Paid"></nz-option>
                  <nz-option nzValue="ON_ARRIVAL" nzLabel="On Arrival "></nz-option>
                  <nz-option nzValue="PART_PREPAID" nzLabel="Part pre-paid"></nz-option>
                  <nz-option nzValue="CREDIT" nzLabel="Credit"></nz-option>
                  <nz-option nzValue="VOUCHER" nzLabel="Voucher"></nz-option>
                </nz-select>
              </nz-form-control>
              <ng-template #paymentTypeError>
                <span
                  *ngIf="formErrors?.bookingCostInformation?.paymentType?.required">Please select payment type. </span>
              </ng-template>
            </nz-form-item>
            <nz-form-item class="grid grid-flow-row content-start">
              <nz-form-label nzFor="depositId" nzRequired>Refundable Deposit</nz-form-label>
              <nz-form-control [nzErrorTip]="depositError">
                <nz-input-number-group [nzAddOnAfter]="depositAddOnAfterTemplate">
                  <nz-input-number id="depositId" formControlName="deposit" [nzPlaceHolder]="'Enter Number'"
                                   [nzStep]="1"
                                   [nzMin]="0"></nz-input-number>
                </nz-input-number-group>
                <ng-template #depositAddOnAfterTemplate>
                  <nz-select id="depositCurrencyId" formControlName="depositCurrency"
                             [nzPlaceHolder]="'...'"
                             style="width: 75px">
                    <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                               [nzLabel]="op.currencyCode"></nz-option>
                  </nz-select>
                </ng-template>
              </nz-form-control>
              <ng-template #depositError>
                <span *ngIf="formErrors?.bookingCostInformation?.deposit?.required">Please enter value. </span>
              </ng-template>
            </nz-form-item>
          </div>
          <div>
            <h6>Attachments</h6>
            <!--            <div class="mb-3 my-2">Insurance, Revenue License & Eco Test Certificate</div>-->
            <div class="flex flex-col items-center justify-center bg-slate-100 w-full h-32 xl:h-52 py-2">
              <div>
                <nz-upload
                  [nzCustomRequest]="bookingCostInfoUpload" [nzShowUploadList]="false" [nzMultiple]="false">
                  <button nz-button>
                    <span nz-icon nzType="upload"></span>
                    Click to Upload
                  </button>
                </nz-upload>
              </div>
              <div>
                <p *ngIf="bookingCostInfoUploading" class="text-primary my-2">Uploading...</p>
              </div>
              <div class="mt-2 overflow-auto">
                <div *ngFor="let file of bookingCostInfoUploadFiles; let i = index"
                     class="flex justify-between items-center mx-3 gap-5">
                  <a target="_blank" href="{{file.url}}">{{ file.name }}</a>
                  <span nz-icon nzType="close-circle" nzTheme="outline" [nzTheme]="'twotone'"
                        [nzTwotoneColor]="'#ff0000'"
                        class="cursor-pointer" nz-popconfirm
                        nzPopconfirmTitle="Are you sure you want to delete this attachment"
                        (nzOnConfirm)="removeUploadFile(i, 'booking-cost-info')"
                  ></span>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="grid xl:grid-cols-4 gap-2 mt-2" formGroupName="bookingCostInformation">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="totalRentalAmountId" nzRequired>{{
                (rentBookingForm?.get('bookingCostInformation')?.get('paymentType')?.value === 'CREDIT') ? 'Total Credit Amount' : 'Total Rental Amount'
              }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="totalRentalAmountError">
              <!--              <input nz-input type="text" formControlName="totalRentalAmount" placeholder="Enter Number"/>-->
              <nz-input-number-group [nzAddOnAfter]="totalRentalAmountAddOnAfterTemplate">
                <nz-input-number id="totalRentalAmountId" formControlName="totalRentalAmount"
                                 [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                 [nzMin]="0"></nz-input-number>
              </nz-input-number-group>
              <ng-template #totalRentalAmountAddOnAfterTemplate>
                <nz-select id="totalRentalAmountCurrencyId" formControlName="totalRentalAmountCurrency"
                           [nzPlaceHolder]="'...'"
                           style="width: 75px">
                  <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                             [nzLabel]="op.currencyCode"></nz-option>
                </nz-select>
              </ng-template>
            </nz-form-control>
            <ng-template #totalRentalAmountError>
              <!--              <span *ngIf="formErrors.bookingCostInfo.totalRentalAmount.required">Please enter name. </span>-->
              <!--              <span *ngIf="formErrors.bookingCostInfo.totalRentalAmount.maxlength">Maximum 70 letters only. </span>-->
              <!--              <span *ngIf="formErrors.bookingCostInfo.totalRentalAmount.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
            </ng-template>
          </nz-form-item>
          <nz-form-item
            *ngIf="rentBookingForm?.get('bookingCostInformation')?.get('paymentType')?.value !== 'ON_ARRIVAL'"
            class="grid grid-flow-row content-start">
            <nz-form-label nzFor="prepaidAmountId">Prepaid Amount</nz-form-label>
            <nz-form-control [nzErrorTip]="prepaidAmountError">
              <nz-input-number-group [nzAddOnAfter]="prepaidAmountAddOnAfterTemplate">
                <nz-input-number id="prepaidAmountId" formControlName="prepaidAmount" [nzPlaceHolder]="'Enter Number'"
                                 [nzStep]="1"
                                 [nzMin]="0"></nz-input-number>
              </nz-input-number-group>
              <ng-template #prepaidAmountAddOnAfterTemplate>
                <nz-select id="prepaidAmountCurrencyId" formControlName="prepaidAmountCurrency"
                           [nzPlaceHolder]="'...'"
                           style="width: 75px">
                  <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                             [nzLabel]="op.currencyCode"></nz-option>
                </nz-select>
              </ng-template>
            </nz-form-control>
            <ng-template #prepaidAmountError>
              <!--              <span *ngIf="formErrors.bookingCostInfo.prepaidAmount.required">Please enter name. </span>-->
              <!--              <span *ngIf="formErrors.bookingCostInfo.prepaidAmount.maxlength">Maximum 70 letters only. </span>-->
              <!--              <span *ngIf="formErrors.bookingCostInfo.prepaidAmount.pattern">Only allowed letters, please avoid adding special characters or numbers. </span>-->
            </ng-template>
          </nz-form-item>
          <nz-form-item *ngIf="rentBookingForm?.get('bookingCostInformation')?.get('paymentType')?.value !== 'PREPAID'"
                        class="grid grid-flow-row content-start">
            <nz-form-label nzFor="rentalAmountDueId">
              {{
                (rentBookingForm?.get('bookingCostInformation')?.get('paymentType')?.value === 'CREDIT') ? 'Credit Amount Due' : 'Rental Amount Due'
              }}
            </nz-form-label>
            <nz-form-control [nzErrorTip]="rentalAmountDueError">
              <nz-input-number-group [nzAddOnAfter]="rentalDueAddOnAfterTemplate">
                <nz-input-number id="rentalAmountDueId" formControlName="rentalAmountDue"
                                 [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                 [nzMin]="0"></nz-input-number>
              </nz-input-number-group>
              <ng-template #rentalDueAddOnAfterTemplate>
                <nz-select id="rentalAmountDueCurrency" formControlName="rentalAmountDueCurrency"
                           [nzPlaceHolder]="'...'"
                           style="width: 75px">
                  <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                             [nzLabel]="op.currencyCode"></nz-option>
                </nz-select>
              </ng-template>
            </nz-form-control>
            <ng-template #rentalAmountDueError>
            </ng-template>
          </nz-form-item>
        </div>

        <h6 class="my-2">Extra Charges</h6>
        <div>
          <div class="grid xl:grid-cols-1 gap-2" formGroupName="bookingCostInformation">
            <div>
              <div formArrayName="extraCharges" *ngFor="let extra of extraCharges.controls; let costIndex = index">
                <div class="grid sm:grid-cols-5 gap-2">
                  <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeType" nzRequired>Charge Type
                  </nz-form-label>
                  <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeCost" nzRequired>Value
                  </nz-form-label>
                </div>
                <div class="grid sm:grid-cols-5 gap-6 sm-gap-2 my-1">
                  <nz-form-item [formGroupName]="costIndex" class="col-span-2 grid grid-flow-row content-start mb-0">
                    <!--                    <nz-form-label *ngIf="costIndex === 0" nzFor="chargeType" nzRequired>Charge Type</nz-form-label>-->
                    <nz-form-control [nzErrorTip]="chargeTypeError">
                      <nz-select class="w-full" id="chargeTypeId" formControlName="chargeType"
                                 nzPlaceHolder="Select Preference"
                                 nzShowSearch nzAllowClear [nzDropdownRender]="renderTemplate">
                        <nz-option class="w-full" *ngFor="let item of chargesOptions" [nzLabel]="item"
                                   [nzValue]="item"></nz-option>
                      </nz-select>
                      <ng-template #renderTemplate>
                        <nz-divider></nz-divider>
                        <div class="flex flex-col justify-center mx-3">
                          <input type="text" nz-input #inputElement/>
                          <a class="text-center m-1" (click)="addItem(inputElement)">
                            <span nz-icon nzType="plus"></span>
                            Add item
                          </a>
                        </div>
                      </ng-template>
                    </nz-form-control>
                    <ng-template #chargeTypeError>
                      <span
                        *ngIf="formErrors?.bookingCostInformation?.chargeType?.required">Please select charge type. </span>
                    </ng-template>
                  </nz-form-item>
                  <nz-form-item [formGroupName]="costIndex" class="col-span-2 grid grid-flow-row content-start mb-0">
                    <!--                    <nz-form-label *ngIf="costIndex === 0" nzFor="chargeCost" nzRequired>Value</nz-form-label>-->
                    <nz-form-control class="w-full" [nzErrorTip]="chargeCostError">
                      <!--&lt;!&ndash;                      <nz-input-group [nzAddOnAfter]="deleteButton">&ndash;&gt;-->
                      <!--                        <nz-input-number class="w-full" formControlName="chargeCost"-->
                      <!--                                         nzPlaceHolder="Enter Number"></nz-input-number>-->
                      <!--                      </nz-input-group>-->
                      <nz-input-number-group class="w-full" [nzAddOnAfter]="extraAddOnAfterTemplate">
                        <nz-input-number formControlName="amount" [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                         [nzMin]="0"></nz-input-number>
                      </nz-input-number-group>
                      <ng-template #extraAddOnAfterTemplate>
                        <nz-select formControlName="currency"
                                   [nzPlaceHolder]="'...'"
                                   style="width: 75px">
                          <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                                     [nzLabel]="op.currencyCode"></nz-option>
                        </nz-select>
                      </ng-template>
                      <!--                    <input nz-input type="text" formControlName="chargeCost" placeholder="Enter Number"/>-->
                    </nz-form-control>
                    <ng-template #chargeCostError>
                      <span *ngIf="formErrors?.bookingCostInformation?.chargeCost?.required">Please enter value. </span>
                    </ng-template>
                    <ng-template>
                    </ng-template>
                  </nz-form-item>
                  <button class="col-span-1" nz-button nzType="text" nzDanger
                          (click)="deleteExtraCharges(costIndex)"><span nz-icon
                                                                        nzType="delete"
                                                                        nzTheme="outline"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button class="outline-button" nz-button nzType="default" nz-popconfirm
                    (click)="addExtraCharge()">
              <span nz-icon nzType="plus" nzTheme="outline"></span></button>
          </div>
          <div class="flex mt-3">
            <p>Total Extra Charges - </p>
            <p class="ml-3">{{ totalExtraChargesInLKR }} LKR</p>
          </div>
          <nz-divider></nz-divider>
        </div>

        <h6 class="my-2">Deductions</h6>
        <div>
          <div class="grid xl:grid-cols-1 gap-2" formGroupName="bookingCostInformation">
            <div>
              <div formArrayName="deductions" *ngFor="let deduct of deductions.controls; let costIndex = index">
                <div class="grid sm:grid-cols-5 gap-2">
                  <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeType" nzRequired>Charge Type
                  </nz-form-label>
                  <nz-form-label class="col-span-2" *ngIf="costIndex === 0" nzFor="chargeCost" nzRequired>Value
                  </nz-form-label>
                </div>
                <div class="grid sm:grid-cols-5 gap-6  my-1">
                  <nz-form-item [formGroupName]="costIndex" class="col-span-2 grid grid-flow-row content-start mb-0">
                    <nz-form-control [nzErrorTip]="chargeTypeError">
                      <nz-select class="w-full" id="deductionChargeTypeId" formControlName="chargeType"
                                 nzPlaceHolder="Select Preference"
                                 nzShowSearch nzAllowClear [nzDropdownRender]="renderTemplate">
                        <nz-option *ngFor="let item of deductionOptions" [nzLabel]="item" [nzValue]="item"></nz-option>
                      </nz-select>
                      <ng-template #renderTemplate>
                        <nz-divider></nz-divider>
                        <div class="flex flex-col justify-center mx-3">
                          <input type="text" nz-input #inputElement/>
                          <a class="text-center m-1" (click)="addDeductionItem(inputElement)">
                            <span nz-icon nzType="plus"></span>
                            Add item
                          </a>
                        </div>
                      </ng-template>
                    </nz-form-control>
                    <ng-template #chargeTypeError>
                      <span *ngIf="formErrors?.bookingCostInformation?.chargeType?.required">Please select deduction type. </span>
                    </ng-template>
                  </nz-form-item>
                  <nz-form-item [formGroupName]="costIndex" class="col-span-2 grid grid-flow-row content-start mb-0">
                    <nz-form-control class="w-full" [nzErrorTip]="chargeCostError">
                      <nz-input-number-group class=w-full [nzAddOnAfter]="deductionAddOnAfterTemplate">
                        <nz-input-number id="dedAmountId{{costIndex}}" formControlName="amount"
                                         [nzPlaceHolder]="'Enter Number'" [nzStep]="1"
                                         [nzMin]="0"></nz-input-number>
                      </nz-input-number-group>
                      <ng-template #deductionAddOnAfterTemplate>
                        <nz-select id="dedCurrency{{costIndex}}" formControlName="currency"
                                   [nzPlaceHolder]="'...'"
                                   style="width: 75px">
                          <nz-option *ngFor="let op of currencyOptions" [nzValue]="op._id"
                                     [nzLabel]="op.currencyCode"></nz-option>
                        </nz-select>
                      </ng-template>
                      <!--                    <input nz-input type="text" formControlName="chargeCost" placeholder="Enter Number"/>-->
                    </nz-form-control>
                    <ng-template #chargeCostError>
                      <span *ngIf="formErrors?.bookingCostInformation?.chargeCost?.required">Please enter value. </span>
                    </ng-template>
                  </nz-form-item>
                  <button class="col-span-1" nz-button nzType="text" nzDanger
                          (click)="deleteDeductions(costIndex)"><span nz-icon
                                                                      nzType="delete"
                                                                      nzTheme="outline"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div>
            <button class="outline-button mt-2" nz-button nzType="default" nz-popconfirm
                    (click)="addDeduction()"><span
              nz-icon nzType="minus" nzTheme="outline"></span></button>
          </div>
          <div class="flex mt-3">
            <p>Total Deductions - </p>
            <p class="ml-3">{{ totalDeductionsInLKR }} LKR</p>
          </div>
          <nz-divider></nz-divider>
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section class="mt-6">
  <nz-card>
    <div class="">
      <h5 class="text-primary">Other Details</h5>
      <form nz-form [formGroup]="rentBookingForm" [nzLayout]="'vertical'">
        <div class="grid xl:grid-cols-2 gap-2" formGroupName="otherDetails">
          <nz-form-item class="grid grid-flow-row content-start">
            <nz-form-label nzFor="specialInstructionId">Special Instructions</nz-form-label>
            <nz-form-control [nzErrorTip]="specialInstructionError">
              <textarea id="specialInstructionId" nz-input formControlName="specialInstruction"
                        placeholder="Enter Remarks"
                        [nzAutosize]="{ minRows: 7, maxRows: 7 }"></textarea>
            </nz-form-control>
            <ng-template #specialInstructionError>
              <span *ngIf="formErrors.otherDetails.specialInstruction.maxlength">Maximum 150 letters only. </span>
            </ng-template>
          </nz-form-item>
          <!--          <nz-form-item class="grid grid-flow-row content-start">-->
          <!--            <nz-form-label nzFor="userComment">User Comments</nz-form-label>-->
          <!--            <nz-form-control [nzErrorTip]="userCommentError">-->
          <!--              <textarea nz-input formControlName="userComment" placeholder="Enter Remarks"-->
          <!--                        [nzAutosize]="{ minRows: 7, maxRows: 7 }"></textarea>-->
          <!--            </nz-form-control>-->
          <!--            <ng-template #userCommentError>-->
          <!--              <span *ngIf="formErrors.otherDetails.userComment.maxlength">Maximum 150 letters only. </span>-->
          <!--            </ng-template>-->
          <!--          </nz-form-item>-->
        </div>
      </form>
    </div>
  </nz-card>
</section>

<section class="mt-6">
  <nz-card>
    <div class="flex justify-end">
      <button class="outline-button mr-3" nz-button nzType="default" nz-popconfirm
              nzPopconfirmTitle="Are you sure you want to cancel this rent booking? You will lost all data."
              [nzOkText]="'Yes'" [nzCancelText]="'No'" (nzOnCancel)="bookingCancelNo()"
              (nzOnConfirm)="bookingCancelConfirm()"
      >Cancel
      </button>
      <button nz-button nzType="primary" nz-popconfirm
              nzPopconfirmTitle="{{reservationId ? 'Are you sure you want to save this information' : 'Are you sure you want to add new rent booking?'}}"
              [nzOkText]="'Yes'" [nzCancelText]="'No'"
              (nzOnCancel)="bookingCancelNo()"
              (nzOnConfirm)="submit()"
              [disabled]="rentBookingForm.invalid || !this.numberOfDays">Update Booking
      </button>
    </div>
    <nz-alert *ngIf="actionMessage.display" class="mt-2" [nzType]="actionMessage.type"
              [nzMessage]="actionMessage.message" nzShowIcon></nz-alert>

  </nz-card>
</section>
</div>
<div [ngClass]="loading ? 'block' : 'hidden'">
  <app-edit-view-skeleton-template></app-edit-view-skeleton-template>
</div>

<app-add-agent-popup [isVisible]="visibleAddAgentPopup"
                     (addEditAgentOnChange)="onGetAddAgentChange($event)"></app-add-agent-popup>

<app-add-customer-popup [isVisible]="visibleAddCustomerPopup"
                        (addEditCustomerOnChange)="onGetAddCustomerChange($event)"></app-add-customer-popup>

<app-add-driver-popup [isVisible]="visibleAddDriverPopup"
                      (addEditDriverOnChange)="onGetAddDriverChange($event)"></app-add-driver-popup>

<app-vehicle-details-form [isVisible]="visibleAddVehicleToSupplier" (addVehicleOnChange)="addVehicleOnChange($event)"
                          [supplier]="selectedSupplierId"></app-vehicle-details-form>
